import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { IdentityScreen } from '../../../enums'
import { LoginService } from '../services/login-service'
import { LoginRadiusWidget, LRWidgetType } from './base'

export class ForgotPasswordWidget extends LoginRadiusWidget {

    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.FORGOT_PASSWORD
        this.lrObject = lrObject
        this.container = container
    }

    /**
     * Callback function used by LR widget
     * @param response any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onSuccess(response: any) {
        logger('info', response)
        LoginService.clearErrors()
        // switch to success page
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)

        LoginService.setRedirectLink()
        LoginService.sendFormSubmissionEvent('forgot-password')
    }

    /**
     * Callback function used by LR widget
     * @param errors any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onError(errors: any) {
        logger('error', errors)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
        LoginService.sendSubmissionErrorAnalytics(errors, 'forgot-password')
    }
}
